export const getPlaceholderStyles = styles => {
  return {
    '::-webkit-input-placeholder': Object.assign({}, styles),
    '::-moz-placeholder': Object.assign({
      opacity: 1
    }, styles),
    ':-ms-input-placeholder': Object.assign({}, styles)
  };
};